function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "Icon-fill",
  fill: "#FFF",
  d: "M9.728 20.92L.536 23.04l2.121-9.192"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "Icon-stroke",
  stroke: "#6273C9",
  d: "M8.737 20.635L2.942 14.84l-1.739 7.534 7.534-1.739z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "Icon-fill",
  fill: "#FFF",
  d: "M9.728 20.92l-7.07-7.071 9.899-9.9 7.071 7.071z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "Icon-stroke",
  stroke: "#6273C9",
  d: "M9.728 20.213l-6.363-6.364 9.192-9.193 6.364 6.364z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "Icon-fill",
  fill: "#FFF",
  d: "M20.335 10.313l-7.071-7.071 2.121-2.121a3 3 0 014.243 0l2.828 2.828a3 3 0 010 4.243l-2.12 2.121z"
}), /*#__PURE__*/React.createElement("path", {
  "data-svg-class": "Icon-stroke",
  stroke: "#6273C9",
  d: "M20.335 9.606l1.768-1.768a2.5 2.5 0 000-3.535l-2.829-2.829a2.5 2.5 0 00-3.535 0L13.97 3.242l6.364 6.364z"
}));

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.b6d99582.svg";
export { ForwardRef as ReactComponent };